var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:'t-' + _vm.theme,attrs:{"id":"app"}},[_c('Menu'),_c('router-view'),_c('Footer'),_c('notifications',{staticClass:"w-100 mb-5",attrs:{"group":"app","position":"bottom left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }